import React, { useState, useEffect } from 'react';
import RoutineEditor from './components/RoutineEditor';
import DailyLogger from './components/DailyLogger';
import SummaryGenerator from './components/SummaryGenerator';
import ShareWithNanny from './components/ShareWithNanny';
import sampleData from './data/sampleRoutine.json';

function App() {
  const [activeTab, setActiveTab] = useState('routine');
  const [routine, setRoutine] = useState(sampleData.routine);
  const [dailyLog, setDailyLog] = useState({});
  const [isCaregiverMode, setIsCaregiverMode] = useState(false);

  // Load data from localStorage on component mount
  useEffect(() => {
    const savedRoutine = localStorage.getItem('babyday-routine');
    const savedDailyLog = localStorage.getItem('babyday-daily-log');
    
    if (savedRoutine) {
      setRoutine(JSON.parse(savedRoutine));
    }
    
    if (savedDailyLog) {
      setDailyLog(JSON.parse(savedDailyLog));
    }
  }, []);

  // Save routine to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('babyday-routine', JSON.stringify(routine));
  }, [routine]);

  // Save daily log to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('babyday-daily-log', JSON.stringify(dailyLog));
  }, [dailyLog]);

  const handleRoutineUpdate = (updatedRoutine) => {
    setRoutine(updatedRoutine);
  };

  const handleLogUpdate = (eventId, logData) => {
    setDailyLog(prev => ({
      ...prev,
      [eventId]: logData
    }));
  };

  const tabs = [
    { id: 'routine', label: '📅 Routine', component: RoutineEditor },
    { id: 'logger', label: '📝 Daily Log', component: DailyLogger },
    { id: 'summary', label: '📊 Summary', component: SummaryGenerator },
    { id: 'share', label: '👥 Share', component: ShareWithNanny }
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="container">
      <div className="header">
        <h1>🌸 BabyDay</h1>
        <p>Smart Scheduler for Moms & Nannies</p>
      </div>

      <div className="card">
        <div className="tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {ActiveComponent && (
          <ActiveComponent
            routine={routine}
            dailyLog={dailyLog}
            onRoutineUpdate={handleRoutineUpdate}
            onLogUpdate={handleLogUpdate}
            isCaregiverMode={isCaregiverMode}
            setIsCaregiverMode={setIsCaregiverMode}
            categories={sampleData.categories}
          />
        )}
      </div>
    </div>
  );
}

export default App; 